import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base';
import { Validators, FormGroup } from '@angular/forms';
import { Element } from '@angular/compiler';

@Component({
    selector: 'usuario-etapa1',
    templateUrl: './usuario-etapa1.component.html',
})
export class CrudUsuarioEtapa1Component extends BaseStepComponent {
    @Input() unidadesOptions: SelectItem[];
}


// WEBPACK FOOTER //
// ./src/app/usuario/crud/etapas/usuario-etapa1.component.ts